export default "__VITE_ASSET__f990598c__$_?component__"